import React from 'react';
import 'swiper/css'; // eslint-disable-line import/no-unresolved
import 'swiper/css/navigation'; // eslint-disable-line import/no-unresolved
import 'swiper/css/pagination'; // eslint-disable-line import/no-unresolved
import {
  Navigation,
  A11y,
  Keyboard,
  Pagination,
} from 'swiper/modules'; // eslint-disable-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react'; // eslint-disable-line import/no-unresolved
import styled from 'styled-components';
import { onSlideChange } from '../swiper';
import Image from '../image';
import Video from '../video';
import Overlay from './overlay';
import useMediaPopup from './use-media-popup';

const MediaPopupComponent = ({
  className,
  imageSlides = [],
  imageOptions = [],
  videos = [],
  popupPreferRemote = false,
}) => {
  const {
    imagesIsOpen,
    currentImage,
    videosIsOpen,
  } = useMediaPopup();

  return (
    <div className={className}>
      {(imagesIsOpen || videosIsOpen) && (
        <>
          <Overlay />
          <Popup>
            {videosIsOpen && (
              <Swiper
                modules={[Navigation, A11y]}
                watchOverflow
                navigation
                onSlideChange={onSlideChange(videos, { name: 'Video popup', loop: false })}
              >
                {videos.map((video) => (
                  <SwiperSlide key={video.videocode}>
                    <SlideInner>
                      <Video
                        source={video.source}
                        video={video.videocode}
                      />
                    </SlideInner>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}

            {imagesIsOpen && (
              <Swiper
                modules={[Navigation, A11y, Keyboard, Pagination]}
                pagination
                navigation
                keyboard={{
                  enabled: true,
                }}
                watchOverflow
                onSwiper={(swiper) => swiper.slideTo(currentImage)}
                onSlideChange={onSlideChange(imageSlides.filter(({ image }) => image), { name: 'Image popup', loop: false })}
              >
                {imageSlides.map(({ image, alt, onIsActive }) => image && (
                  <SwiperSlide key={image.id}>
                    {({ isActive }) => {
                      if (isActive) {
                        setTimeout(() => {
                          if (onIsActive) {
                            onIsActive(true);
                          }
                        }, 1);
                      }
                      return (
                        <SlideInner>
                          <Image
                            preferRemote={popupPreferRemote}
                            image={image}
                            options={imageOptions}
                            alt={alt}
                          />
                        </SlideInner>
                      );
                    }}
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </Popup>
        </>
      )}
    </div>
  );
};

const SlideInner = styled.div`
  margin: 0 auto;
  text-align: center;

  img {
    max-width: 90vw;
    max-height: 80vh;
    max-height: 80dvh;
    object-fit: contain;
  }
`;

const Popup = styled.div`
  position: fixed;
  margin-left: auto;
  margin-right: auto;
  top: 15vh;
  top: 15dvh;
  left: 1rem;
  right: 1rem;
  z-index: 10;

  --swiper-pagination-color: ${({ theme }) => theme.primaryColor};
  --swiper-pagination-bullet-inactive-color: white;
  .swiper-pagination {
    position: fixed;
  }

  .swiper-button-prev {
    left: 0.25rem;
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      left: 1rem;
    }
  }
  .swiper-button-next {
    right: 0.25rem;
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      right: 1rem;
    }
  }
  [class^="swiper-button-"] {
    color: white;
    background-color: rgba(0, 0, 0, 0.2);
    padding: .5rem;
    &:after {
      font-size: 1rem;
      @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
        font-size: 1.5rem;
      }
    }
    &.swiper-button-disabled {
      display: none;
    }
  }

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
  }
`;

export default styled(MediaPopupComponent)`
  position: absolute;
`;
